import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DayDetails, NightCycleDetails, NightDetails } from '../interfaces';
import { UserService } from '@shared/services/user.service';

@Component({
  selector: 'app-effective-needs-details-popup',
  templateUrl: './effective-needs-details-popup.component.html',
  styleUrls: ['./effective-needs-details-popup.component.scss'],
  standalone: false,
})
export class EffectiveNeedsDetailsPopupComponent implements OnInit {
  public title: string | undefined;

  public subTitle: string | undefined;

  public lastUpdateDate: string | undefined;

  public showDifference: boolean = false;

  public onlyNeeds: boolean = false;

  public period: string | undefined;

  public isCycleConfig = false;

  public details: DayDetails[] | NightDetails[] | NightCycleDetails[] | undefined;

  public populationsDetails: any;

  public onlyMorning = false;

  public onlyAfternoon = false;

  constructor(
    private readonly dialogRef: MatDialogRef<EffectiveNeedsDetailsPopupComponent>,
    @Inject(MAT_DIALOG_DATA) private readonly data: any,
    private readonly userService: UserService
  ) {}

  ngOnInit() {
    this.title = this.data.title;
    this.subTitle = this.data.subTitle;
    this.lastUpdateDate = this.data.lastUpdateDate;
    this.period = this.data.period;
    this.details = this.data.details;
    this.addHospitalsDisplayName();
    this.onlyMorning = this.data.onlyMorning;
    this.onlyAfternoon = this.data.onlyAfternoon;
    this.isCycleConfig = this.data.isCycleConfig;
    this.populationsDetails = this.data.populationsDetails;

    this.showDifference = true;
    if (this.data.showDifference !== undefined) {
      this.showDifference = this.data.showDifference;
    }
    this.onlyNeeds = false;
    if (this.data.onlyNeeds !== undefined) {
      this.onlyNeeds = this.data.onlyNeeds;
    }
  }

  addHospitalsDisplayName() {
    this.details?.forEach((item: any) => {
      item.hospital.displayName = this.userService.resolveHospitalName(item.hospital._id);
    });
  }

  getDifference(arg: { effective: number; needs: number }): number {
    return arg.effective - arg.needs;
  }

  objectifStatus(population: any) {
    if (
      population.morning.effective < population.morning.needs ||
      population.afternoon.effective < population.afternoon.needs
    ) {
      return 'ERROR';
    } else {
      return 'OK';
    }
  }

  close() {
    this.dialogRef.close();
  }
}
